import SatisfactionGuaranteedSection from './satisfaction_guaranteed_section';

export default SatisfactionGuaranteedSection;
